import React, { FunctionComponent, useEffect, useState } from "react";
import { article } from "@Api";
import cx from "classnames";

import styles from "./index.module.less";

interface IProps {
  kindId: string;
  handleClick: (data: any) => void;
}

interface TabType {
  name: string;
  child: { name: string }[];
}

const { fetchArticleNav } = article;

const TabBar: FunctionComponent<IProps> = ({ kindId, handleClick }) => {
  const [active, setActive] = useState(0);
  const [childActive, setChildActive] = useState(0);
  const [tabBar, setTab] = useState<TabType[]>([]);

  const fetch = async () => {
    try {
      const res:any = await fetchArticleNav({ kindId: kindId });
      const newList: any = [
        {
          name: "全部",
          child: [],
        },
      ].concat(res.data.nav);

      setTab(newList);
      if (window.location.hash !== "") {
        const key = decodeURIComponent(window.location.hash).replace("#", "");
        const index = newList.map((item) => item.name).indexOf(key);
        if (index !== -1) {
          setActive(index);
          setChildActive(0);
          handleClick({
            contentType1: newList[index].name === "全部" ? undefined : newList[index].name,
            contentType2: newList[index].child[0]?.name,
          });
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetch();
  }, []);



  return (
    <div className={styles["tab-container"]}>
      <div className={styles["tab-bar"]}>
        {tabBar.map((item, index) => {
          return (
            <a
              key={index}
              className={cx(styles["tab-bar-item"], {
                [styles["active"]]: index === active,
              })}
              onClick={() => {
                setActive(index);
                setChildActive(0);
                handleClick({
                  contentType1: item.name === "全部" ? undefined : item.name,
                  contentType2: item.child[0]?.name,
                });
              }}
            >
              {item.name}
            </a>
          );
        })}
      </div>
      {tabBar[active]?.child?.length !== 0 && (
        <div className={styles["tab-bar-children"]}>
          {tabBar[active]?.child.map((item, index) => {
            return (
              <a
                key={index}
                className={cx(styles["tab-child-item"], {
                  [styles["active"]]: index === childActive,
                })}
                onClick={() => {
                  setChildActive(index);
                  handleClick({
                    contentType1: tabBar[active].name,
                    contentType2: item.name,
                  });
                }}
              >
                {item.name}
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TabBar;
